import { MenuItem, Select } from '@mui/material'
import { setUserData } from 'app/redux/actions/UserActions'
import { saveUser } from 'app/services/sfAuth/sfData/sfUser'
import React from 'react'

import { Trans } from '@lingui/macro'
import { portalLanguagesData } from 'app/appSettings'
import { useSnackbar } from 'notistack'
import { useDispatch, useSelector } from 'react-redux'

const SelectLanguageDropdown = () => {
  const [changing, setChanging] = React.useState(false)
  const user = useSelector(state => state.user)
  const allowedLanguages = useSelector(state => state.formRestrictions.allowedLanguages)
  const dispatch = useDispatch()
  const { enqueueSnackbar } = useSnackbar()

  const handleLanguageChange = lang => {
    if (lang !== user.language) {
      setChanging(true)
      const toSave = {
        Id: user.userId,
        Language__c: lang
      }
      if (portalLanguagesData[lang].sfLocale) {
        toSave.LanguageLocaleKey = portalLanguagesData[lang].sfLocale
      }
      saveUser(toSave).then(
        r => {
          dispatch(setUserData({ ...user, language: lang }))
          setChanging(false)
        },
        err => {
          enqueueSnackbar(<Trans>LANGUAGE_SWITCH_ERROR_SNACKBAR</Trans>, {
            variant: 'error'
          })
          setChanging(false)
        }
      )
    }
  }

  return (
    <Select
      disabled={changing}
      variant='outlined'
      value={user.language || 'en'}
      onChange={e => {
        handleLanguageChange(e.target.value)
      }}
      SelectDisplayProps={{
        compact: true,
        id: 'language-change'
      }}
      sx={{ maxWidth: 130, fontSize: 14, color: 'primary.main' }}
    >
      {Object.values(portalLanguagesData).map((obj, index) => {
        const isRestricted = allowedLanguages !== null && !allowedLanguages.includes(obj.editKey)
        return (
          <MenuItem key={index} value={obj.editKey} disabled={isRestricted}>
            {obj.labelTrans}
          </MenuItem>
        )
      })}
    </Select>
  )
}

export default SelectLanguageDropdown
